import { render, staticRenderFns } from "./DayDetails.vue?vue&type=template&id=81f17f24&scoped=true&"
import script from "./DayDetails.vue?vue&type=script&lang=js&"
export * from "./DayDetails.vue?vue&type=script&lang=js&"
import style0 from "./DayDetails.vue?vue&type=style&index=0&id=81f17f24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f17f24",
  null
  
)

export default component.exports